<template>
  <div id="app">
    <!-- 是否缓存页面 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
let tid;
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    let that = this;
    //如果是PC端，监听窗口大小变化，更改mobile状态
    if (!this._isMobile()) {
      window.addEventListener(
        "resize",
        function() {
          clearTimeout(tid);
          tid = setTimeout(that.refresh, 300);
        },
        false
      );
    }
    //页面显示，更改mobile的状态
    window.addEventListener(
      "pageshow",
      function(e) {
        if (e.persisted) {
          clearTimeout(tid);
          tid = setTimeout(that.refresh, 300);
        }
      },
      false
    );
    that.refresh();
  },
  mounted() {},
  methods: {
    //判断是不是移动端，1是移动端，2是PC端
    _isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
    //刷新是否是移动端的状态
    refresh() {
      //获取视口的宽度
      let width = window.document.documentElement.getBoundingClientRect().width;
      // if (width < 1200 || this._isMobile()) {
      //   this.$store.commit('isMobile', 1)
      // } else {
      //   this.$store.commit('isMobile', 0)
      // }
      this.$store.commit("isMobile", 0);
    },
  },
};
</script>

<style lang="scss">
body {
  // display: none;
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
